(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('AddDiseaseDialogController', AddDiseaseDialogController);

    AddDiseaseDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'AddDisease'];

    function AddDiseaseDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, AddDisease) {
        var vm = this;
        vm.addDisease = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:addDiseaseUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.addDisease.id !== null) {
                AddDisease.update(vm.addDisease, onSaveSuccess, onSaveError);
            } else {
                AddDisease.save(vm.addDisease, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
